import { Section } from '@shared/components/Section';
import { BotaoDeContato } from '@inscricao/components/Contato';
import { curso } from '@curso/content/curso';

/**
 * Bloco 12. Responde: o que eu faço agora.
 *
 * Enquanto a inscrição não abre, a lista é a única ação da página, então pode
 * ser a chamada principal sem concorrência. Quando abrir, o botão de saída
 * para o parceiro entra ao lado deste bloco, nunca atrás dele.
 */
export function ChamadaFinal() {
  return (
    <Section
      id="lista"
      fundo="destaque"
      rotulo="Agora"
      titulo="Uma turma pequena. Uma experiência intensiva."
    >
      <p className="prosa max-w-lg text-papel/85">
        Para preservar a qualidade das simulações, das discussões e dos debriefings, a primeira
        turma terá {curso.turma}. As inscrições serão realizadas pelo {curso.parceiroCompleto}.
      </p>
      <p className="prosa mt-4 max-w-lg text-papel/85">
        Entre na lista de interesse e receba o aviso assim que elas forem abertas.
      </p>
      <div className="mt-10 max-w-xl">
        <BotaoDeContato origem="chamada-final" invertido />
      </div>

      <p className="prosa mt-12 max-w-lg text-papel">
        O erro é humano. A capacidade de responder a ele pode ser construída.
      </p>
    </Section>
  );
}
